import React from 'react';
import { Drawer } from '@material-ui/core';

const RightMenuDrawer = ({
  menuComponent,
  menuOpen,
  setMenuOpen,
  setMenuComponent,
}) => {
  return (
    <Drawer
      anchor='right'
      open={menuOpen}
      onClose={() => {
        setMenuOpen(false);
        setTimeout(() => {
          setMenuComponent(undefined);
        }, 200)
      }}
    >
      {menuComponent}
    </Drawer>
  );
};

export default RightMenuDrawer;
